import { IonButton, IonCard, IonCardContent, IonCardTitle, IonIcon, IonImg, IonInput, IonLoading, IonPage, IonPopover, IonSpinner, IonToolbar, isPlatform } from "@ionic/react";
import { User } from "firebase/auth";
import { fetchAndActivate, getValue } from "firebase/remote-config";
import React from "react";
import { isAndroid, isIOS, isMobile } from "react-device-detect";
import { Trans } from "react-i18next";
import { connect } from "react-redux";
import { appVersion } from "../../../appVersion";
import audio3D from "../../../assets/icons/audio3D.png";
import flashCards from "../../../assets/icons/flashCards.png";
import keywords3D from "../../../assets/icons/keywords3D.png";
import map3D from "../../../assets/icons/map3D.png";
import removeResourceIcon from "../../../assets/icons/removeResourceIcon.svg";
import repeatIcon from "../../../assets/icons/repeatIcon.png";
import summary3D from "../../../assets/icons/summary3D.png";
import { sendEvent } from "../../../common/amplitudeUtils";
import { auth, functions, remoteConfig } from "../../../firebaseConfig";
import i18n from "../../../i18n";
import { settingsServices, UserSettings } from "../../settings/store/services";
import { Organization, ResourceUsageEvent, UserLicense } from "../../user/store/reducers";
import { Argument, Session } from "../store/reducers";
import { argumentServices, deleteSessionElement, getLocalStorageSessionState, setLocalStorageSessionState } from "../store/services";
import { checkStatusBar, clearSessionState, getAvailableResources, removeResourceFromLocalStorage, retryReloadArguments } from "../utils/utils";
import "./SessionDetails.css";
import { userServices } from "../../user/store/services";
import { httpsCallable } from "firebase/functions";
import GetPremiumPopover from "../../purchase/components/GetPremiumPopover";
import { Capacitor } from "@capacitor/core";

type Props = {
	history: any;
	orgData: Organization | null;
};

type State = {
	userData: User | null;
	userArguments: Argument[];
	// userArguments: any[],
	remoteConfig: boolean;
	bearerToken: string;
	newArgument: string;
	isProcessingResources: boolean;
	argument: Session | null;
	missingResources: string[];
	summarydocID: string;
	missingSummary: boolean;
	missingAudio: boolean;
	deleteElements: boolean;
	resourceToRemove: string | null,
	eliminateSessionConfirmation: boolean,
	isLoadingMap: boolean;
	isLoadingSummary: boolean;
	isLoadingKeywords: boolean;
	isLoadingFlashcards: boolean;
	isLoadingAudiobook: boolean;
	isFetchingResources: boolean;
	audioLink: string;
	argumentID: string;
	showConfirmationPopover: boolean;
	deleting: boolean,

	showArgumentInputPopover: boolean;
	missingResourceArgumentString: string;
	selectedMissingResourceName: string;
	ttsSettings: UserSettings;
	resourceId: string;
	primaryLanguage: string
	userLicenses: UserLicense[],
	availableResources: any[],
	showPremiumPopover: boolean,
};

class SessionDetails extends React.Component<Props, State> {
	constructor(props: any) {
		super(props);
		this.state = {
			userData: null,
			userArguments: [],
			remoteConfig: false,
			bearerToken: "",
			newArgument: "",
			isProcessingResources: false,
			argument: null,
			missingResources: [],
			summarydocID: "",
			missingSummary: false,
			missingAudio: false,
			audioLink: "",
			argumentID: "",
			deleteElements: false,
			resourceToRemove: "",
			showConfirmationPopover: false,
			eliminateSessionConfirmation: false,

			isLoadingMap: false,
			isLoadingSummary: false,
			isLoadingKeywords: false,
			isLoadingFlashcards: false,
			isLoadingAudiobook: false,
			isFetchingResources: false,
			deleting: false,

			showArgumentInputPopover: false,
			missingResourceArgumentString: "",
			selectedMissingResourceName: "",
			ttsSettings: {
				speech_rate: 1,
				speech_gender: "",
			},
			resourceId: "",
			primaryLanguage: "",
			userLicenses: [],
			availableResources: [],
			showPremiumPopover: false,
		};
	}

	componentDidMount() {
		fetchAndActivate(remoteConfig)
			.then((activated) => {
				if (activated) console.log("Fetched and activated configs!");
				else {
					const remoteConfigValue = getValue(remoteConfig, "showLicenseCode").asBoolean();
					this.setState({ remoteConfig: remoteConfigValue });
				}
			})
			.catch((err) => console.error("Failed to fetch and activate configs", err));
		auth.onAuthStateChanged((userData) => {
			if (userData) {
				userData.getIdToken().then((response) => {
					this.setState({ bearerToken: response, userData: userData }, () => {
						this.setState({ isFetchingResources: true })
						if (this.props.history.location.state.argument) {
							let argument = this.props.history.location.state.argument;
							if (argument) {

								this.setState({ argument: argument, isFetchingResources: true }, () => {
									argumentServices.getUserSessions(userData.uid, this.state.bearerToken, argument.id)
										.then(response => {
											// console.log("new backend resources: ", response[0].resources); //get the first and ONLY element you find
											this.setState(prevState => ({
												argument: {
													...prevState.argument!, resources: response[0].resources
												}
											}), () => {
												this.setState({ isFetchingResources: false })
												console.log(this.state.argument)
											})
										})
										.catch(err => {
											this.setState({ isFetchingResources: false });
											/* TO LOCALIZE THIS */
											alert(i18n.t("Errore nel caricamento delle risorse, se il problema persiste contatta l'assistenza"));
											this.props.history.push('/sessions')
										})
									// console.log(this.state.argument);
								})
							}


						}
						// window.addEventListener('beforeunload', clearSessionState);


					});
					settingsServices.getPrimaryLanguage(userData.uid, response).then(response => {
						console.log(response)
						this.setState({ primaryLanguage: response })
					})
					settingsServices.getUserSettings(userData.uid, response).then((settings) => {
						this.setState({ ttsSettings: settings });
					});
				});



			} else {
				this.setState({
					userData: null,
				});
			}
		});
	}
	componentWillUnmount(): void {
		window.removeEventListener('beforeunload', clearSessionState);

	}

	reloadArguments() {
		let argument = this.props.history.location.state.argument;
		this.setState({ argument: argument }, () => {
			if (this.state.userData)
				argumentServices.getUserSessions(this.state.userData.uid, this.state.bearerToken, argument.id)
					.then(response => {
						this.setState({ isFetchingResources: false })
						// console.log("new backend resources: ", response[0].resources); //get the first and ONLY element you find
						this.setState(prevState => ({
							argument: {
								...prevState.argument!, resources: response[0].resources
							}
						}), () => { console.log(this.state.argument) })
					})
					.catch(err => {
						this.setState({ isFetchingResources: false });
						/* TO LOCALIZE THIS */
						alert(i18n.t("Errore nel caricamento delle risorse, se il problema persiste contatta l'assistenza"));
						this.props.history.push('/sessions')
					})
			// console.log(this.state.argument);
		})
	}
	startReloadWithRetry = () => {
		retryReloadArguments(this)
			.catch(error => {
				console.error('All reload attempts failed:', error);
				// Handle final failure here
			});
	}

	handleSessionState(sessionType: string) {
		let sessionKey = sessionType === "creation" ? "creationSessionState" : "sessionState";
		let storedState = localStorage.getItem(sessionKey);
		let localStorageState = storedState ? JSON.parse(storedState) : [false, null];

		if (localStorageState) {
			let sessionTypes = getLocalStorageSessionState(sessionType, this.state.argument?.id);
			console.log(`${sessionType === "creation" ? "CREATION " : ""}SESSION TYPES:`, sessionTypes);
			let openedConnections = new Set(); // Track opened connections to avoid duplicates

			if (sessionTypes.length > 0) {
				sessionTypes.forEach(session => {
					let sessionResourceType = sessionType === "creation" ? session[2] : session;
					let additionalData = sessionType === "creation" ? session.slice(3) : [];

					switch (sessionResourceType) {
						case "map":
							this.setState({ isLoadingMap: true });
							break;
						case "summaries":
							this.setState({ isLoadingSummary: true });
							break;
						case "keywords_collections":
							this.setState({ isLoadingKeywords: true });
							break;
						case "flashcards_collections":
							this.setState({ isLoadingFlashcards: true });
							break;
						default:
							this.setState({ isLoadingAudiobook: true });
					}
				});
			}
		}
	}
	debounceWithRetry<T extends (...args: any[]) => Promise<any>>(
		fn: T
	): (...args: Parameters<T>) => Promise<ReturnType<T>> {
		let timeoutId: NodeJS.Timeout | null = null;

		return async (...args: Parameters<T>): Promise<ReturnType<T>> => {
			// Clear any existing timeout
			if (timeoutId) {
				clearTimeout(timeoutId);
			}

			return new Promise((resolve, reject) => {
				timeoutId = setTimeout(async () => {
					let lastError: Error | null = null;

					// Initial attempt
					try {
						const result = await fn(...args);
						return resolve(result);
					} catch (error) {
						lastError = error as Error;
					}

					// Retry logic
					for (let attempt = 1; attempt <= 3; attempt++) {
						await new Promise(resolve => setTimeout(resolve, 5000)); // Wait 5 seconds

						try {
							const result = await fn(...args);
							return resolve(result);
						} catch (error) {
							lastError = error as Error;
							console.log(`Retry attempt ${attempt} failed:`, error);
						}
					}

					// If all retries failed, reject with the last error
					reject(lastError);
				}, 30000); // 30 second debounce
			});
		};
	}

	async mapClicked(resourceId: string) {
		sendEvent({
			"user_id": this.state.userData?.uid,
			"event_type": "Map visited",
			"event_properties": {
				"user_org": this.props.orgData !== null ? this.props.orgData.name : "Private User",
				"document_name": this.state.argument?.title ? this.state.argument.title : this.state.argument?.prompt ? this.state.argument?.prompt : "undefined",
			},
			"language": i18n.language,
			"platform": isIOS ? "ios" : isAndroid ? "android" : "desktop",
			"app_version": appVersion,
			"time": Date.now(),
		});
		this.props.history.push({
			pathname: '/maps',
			state: {
				session: this.state.argument,
				mapId: resourceId,
			}
		})
	}
	async summaryClicked(resourceId: string) {
		sendEvent({
			"user_id": this.state.userData?.uid,
			"event_type": "Summary visited",
			"event_properties": {
				"user_org": this.props.orgData !== null ? this.props.orgData.name : "Private User",
				"document_name": this.state.argument?.title ? this.state.argument.title : this.state.argument?.prompt ? this.state.argument?.prompt : "undefined",
			},
			"language": i18n.language,
			"platform": isIOS ? "ios" : isAndroid ? "android" : "desktop",
			"app_version": appVersion,
			"time": Date.now(),
		});
		this.props.history.push({
			pathname: `/summaryView`,
			// pathname: `/summary/${resourceId}`,
			state: { session: this.state.argument, resourceId: resourceId, keywords: false, file_text:false },
		})
	}
	async keywordsClicked(resourceId: string) {
		sendEvent({
			"user_id": this.state.userData?.uid,
			"event_type": "Keywords visited",
			"event_properties": {
				"user_org": this.props.orgData !== null ? this.props.orgData.name : "Private User",
				"document_name": this.state.argument?.title ? this.state.argument.title : this.state.argument?.prompt ? this.state.argument?.prompt : "undefined",
			},
			"language": i18n.language,
			"platform": isIOS ? "ios" : isAndroid ? "android" : "desktop",
			"app_version": appVersion,
			"time": Date.now(),
		});
		this.props.history.push({
			pathname: `/summary/${resourceId}`,
			state: { session: this.state.argument, resourceId: resourceId, keywords: true },
		})
	}
	async audiobookClicked(resourceId: string) {
		if (resourceId) {
			sendEvent({
				"user_id": this.state.userData?.uid,
				"event_type": "Audiobook visited",
				"event_properties": {
					"user_org": this.props.orgData !== null ? this.props.orgData.name : "Private User",
					"document_name": this.state.argument?.title ? this.state.argument.title : this.state.argument?.prompt ? this.state.argument?.prompt : "undefined",
				},
				"language": i18n.language,
				"platform": isIOS ? "ios" : isAndroid ? "android" : "desktop",
				"app_version": appVersion,
				"time": Date.now(),
			});
			this.props.history.push({
				pathname: `/audiobook`,
				state: {
					argument: this.state.argument,
					audiobookId: resourceId,
				},
			});
		}
	}
	async flashCardsClicked(resourceId: string) {
		if (resourceId) {
			sendEvent({
				"user_id": this.state.userData?.uid,
				"event_type": "Flashcards visited",
				"event_properties": {
					"user_org": this.props.orgData !== null ? this.props.orgData.name : "Private User",
					"document_name": this.state.argument?.title,
				},
				"language": i18n.language,
				"platform": isIOS ? "ios" : isAndroid ? "android" : "desktop",
				"app_version": appVersion,
				"time": Date.now(),
			});
			this.props.history.push({
				pathname: `/flashcards`,
				state: {
					argument: this.state.argument,
					flashcardUuid: resourceId,
				},
			});
		}
	}
	startResourceLoading(resourceName: string) {
		console.log(resourceName);
		document.getElementById(`delete-${resourceName}`)!.style.display = "none"
		document.getElementById(`delete-spinner-${resourceName}`)!.style.display = "block"
		resourceName === "maps"
			? this.setState({ isLoadingMap: true })
			: resourceName === "summaries"
				? this.setState({ isLoadingSummary: true })
				: resourceName === "keywords_collections"
					? this.setState({ isLoadingKeywords: true })
					: resourceName === "flashcards_collections"
						? this.setState({ isLoadingFlashcards: true })
						: this.setState({ isLoadingAudiobook: true });
	}

	generateMissingResource(resourceName: string) {
		/* TODO REBUILD ALL THIS LOGIC */
		if (auth.currentUser && auth.currentUser.uid && this.state.argument) {
			auth.currentUser.getIdToken().then(async (response) => {
				resourceName === "maps"
					? this.setState({ isLoadingMap: true })
					: resourceName === "summaries"
						? this.setState({ isLoadingSummary: true })
						: resourceName === "keywords_collections"
							? this.setState({ isLoadingKeywords: true })
							: resourceName === "flashcards_collections"
								? this.setState({ isLoadingFlashcards: true })
								: this.setState({ isLoadingAudiobook: true });
				// if (/* was not from file */)
				/* argumentServices.getSessionArguments
					.call(this, "", response, auth.currentUser!.uid, this.state.argument!.title, this.state.argument?.title, resourceName, this.state.argument!)
					.then((resp) => {
						console.log("generated new resource: ", resp);
						// let missingRes = this.state.missingResources
						// missingRes.splice(missingRes.indexOf(resourceName), 1)
						window.location.reload();
					})
					.catch((err) => {
						//handle err
					}); */
			});
		}
	}
	async handleResourceGeneration(resource: string) {
		if (this.state.userData) {
			let resourceUsage: ResourceUsageEvent[] = await userServices.getResourceUsageEvents(this.state.userData.uid, this.state.bearerToken)
			await getAvailableResources.call(this, this.state.userData, this.state.bearerToken, resourceUsage).then(async response => {
				let generatedResource

				if (this.state.availableResources.find(res => res.available > 0 || res.available === null)) { //* THERE IS AT LEAST ONE RESOURCE AVAILABLE
					let prompt = ""
					let title = ""
					let content = ""
					if (this.state.argument?.prompt === null && this.state.argument.title) {
						prompt = this.state.argument.title
						title = this.state.argument.title
						content = this.state.argument.title
					}
					else if (this.state.argument && this.state.argument.prompt && this.state.argument.title) {
						prompt = this.state.argument.prompt
						title = this.state.argument.title
						content = this.state.argument.prompt
					}
					if (this.state.argument) {
						if (resource === "maps" && this.state.availableResources.find(res => res.resource_type === 'map' && (res.available > 0 || res.available === null))) {
							this.setState({ isLoadingMap: true })
							await argumentServices.createConceptualMap(this.state.bearerToken, this.state.primaryLanguage, this.state.argument?.id, prompt).then((response) => {
								this.setState({ isLoadingMap: false })
								if (response) {
									generatedResource = 'map'
									this.reloadArguments()
								}
								else {
									this.startReloadWithRetry();
								}
							})
						} else if (resource === "summaries" && this.state.availableResources.find(res => res.resource_type === 'summary' && (res.available > 0 || res.available === null))) {
							this.setState({ isLoadingSummary: true })
							await argumentServices.createSummary(this.state.bearerToken, this.state.primaryLanguage, this.state.argument?.id, content, prompt, title).then((response) => {
								this.setState({ isLoadingSummary: false })
								if (response) {
									generatedResource = 'summary'
									this.reloadArguments()
								}
								else {
									this.startReloadWithRetry();
								}
							})
						} else if (resource === "keywords_collections" && this.state.availableResources.find(res => res.resource_type === 'keywords' && (res.available > 0 || res.available === null))) {
							this.setState({ isLoadingKeywords: true })
							await argumentServices.createKeywordsCollection(this.state.bearerToken, this.state.primaryLanguage, this.state.argument?.id, prompt, title).then((response) => {
								this.setState({ isLoadingKeywords: false })
								if (response) {
									generatedResource = 'keywords'
									this.reloadArguments()
								}
								else {
									this.startReloadWithRetry();
								}
							})
						} else if (resource === "audiobooks" && this.state.availableResources.find(res => res.resource_type === 'tts' && (res.available > 0 || res.available === null))) {
							this.setState({ isLoadingAudiobook: true })
							await argumentServices.createAudiobook(this.state.bearerToken, this.state.argument?.id, prompt, this.state.primaryLanguage).then((response) => {
								this.setState({ isLoadingAudiobook: false })
								if (response) {
									generatedResource = 'tts'
									this.reloadArguments()
								}
								else {
									this.startReloadWithRetry();
								}
							})
						} else if (resource === "flashcards_collections" && this.state.availableResources.find(res => res.resource_type === 'flashcards' && (res.available > 0 || res.available === null))) {
							this.setState({ isLoadingFlashcards: true })
							await argumentServices.createFlashcardsCollection(this.state.bearerToken, this.state.primaryLanguage, this.state.argument?.id, prompt, title).then((response) => {
								this.setState({ isLoadingFlashcards: false })
								if (response) {
									generatedResource = 'flashcards'
									this.reloadArguments()
								} else {
									this.startReloadWithRetry();
								}
							})
						}
						else {
							this.setState({ showPremiumPopover: true })
						}
					}
					if (generatedResource) {
						removeResourceFromLocalStorage(generatedResource)
					}
				}
				else {
					/*
					 TODO: SHOW PAYWALL
					 */
					this.setState({ showPremiumPopover: true })
				}
			})
		}

	}

	paletteColors = ["#C7DEFF", "#FFCCDC", "#BDBDFF", "#FCD9CA", "#C7F6D1"];
	render() {
		return (
			<IonPage className="sessionDetailsPage body">

				{this.state.argument && (
					<div className="sessionDetailsMainDiv">
						{(isMobile) && <IonToolbar className="toolbarNotch" style={{ height: checkStatusBar() }}  ></IonToolbar>}

						<IonButton
							className="sessionsDetailsGoBackBtn"
							onClick={() => {
								this.props.history.push("/sessions");
							}}
						>
							<Trans>
								Torna indietro
							</Trans>
						</IonButton>
						<div className="sessionsHomeOnboardingTitle">
							<p className="sessionDetailTitle">"{this.state.argument?.title}"</p>
							<div className="delete-btns-container">
								<IonButton
									className="sessionDetailRemoveButton"
									onClick={() => {
										if (!this.state.deleteElements) {
											this.state.argument!.resources && Object.keys(this.state.argument!.resources).map((resource, i) => {
												let resourceData = Object.values(this.state.argument!.resources!)[i][0]
												if (resourceData) {
													console.log(resourceData)

													let element = document.getElementById(`card-${resource}`);
													if (element) {
														document.getElementById(`delete-${resource}`)!.style.display = "block"
														element.classList.add("wobbleAnimation");
														(element as HTMLElement).style.padding = "0";
														(element as HTMLElement).style.paddingBottom = "15px";
														this.setState({ deleteElements: true });
													}
												}
											})

										} else {
											this.state.argument!.resources && Object.keys(this.state.argument!.resources).map((resource, i) => {
												let element = document.getElementById(`card-${resource}`);
												if (element) {
													document.getElementById(`delete-${resource}`)!.style.display = "none"
													element.classList.remove("wobbleAnimation");
													(element as HTMLElement).style.padding = "unset";
													(element as HTMLElement).style.paddingBottom = "15px";
													this.setState({ deleteElements: false });
												}

											})

											// let elements = document.getElementsByClassName("sessionDetailsResourceCard");
											// for (let i = 0; i < elements.length; i++) {
											// 	elements[i].classList.remove("wobbleAnimation");
											// 	(elements[i] as HTMLElement).style.padding = "unset";
											// 	(elements[i] as HTMLElement).style.paddingBottom = "15px";
											// }
										}
									}}
								>
									{this.state.deleteElements ?
										i18n.t("Annulla") :
										i18n.t("Rimuovi risorsa")
									}
								</IonButton>
								<IonButton
									className="sessionDetailRemoveButton"
									onClick={() => {
										this.setState({ eliminateSessionConfirmation: true })
									}}
								>
									{i18n.t("Elimina sessione")}
								</IonButton>
							</div>
						</div>

						<div className={"sessionDetailsResourcesGrid fullGrid"}>


							{this.state.argument.resources && Object.keys(this.state.argument.resources).map((resource, i) => {
								let resourceData = Object.values(this.state.argument!.resources!)[i][0] //selecting the first and only resource present -> only one resource per session at the moment
								return (
									<IonCard
										className={`sessionDetailsResourceCard fullGridCard res_${resource}`}
										style={{ background: this.paletteColors[i] }}
										disabled={(this.state.isLoadingMap && resource == "maps") ||
											(this.state.isLoadingSummary && resource === "summaries") ||
											(this.state.isLoadingKeywords && resource === "keywords_collections") ||
											(this.state.isLoadingFlashcards && resource === "flashcards_collections") ||
											(this.state.isLoadingAudiobook && resource === "audiobooks")}
										key={i}
										id={`card-${resource}`}
										onClick={() => {
											if (resourceData && resourceData.id) {
												if (resource === "maps") {
													this.mapClicked(resourceData.id,);
												} else if (resource === "summaries") {
													this.summaryClicked(resourceData.id);
												} else if (resource === "keywords_collections") {
													this.keywordsClicked(resourceData.id);
												} else if (resource === "audiobooks") {
													this.audiobookClicked(resourceData.id);
												} else if (resource === "flashcards_collections") {
													this.flashCardsClicked(resourceData.id);
												}
											}
											else {
												this.handleResourceGeneration(resource)

											}
										}}
										onMouseOver={(e) => {
											if (!resourceData) {
												document.getElementById(`resourceImg-${i}`)!.style.opacity = "1";
												(document.getElementById(`resourceImg-${i}`) as HTMLIonImgElement)!.src = repeatIcon;
											}
										}}
										onMouseOut={(e) => {
											if (!resourceData) {
												document.getElementById(`resourceImg-${i}`)!.style.opacity = ".2";
												(document.getElementById(`resourceImg-${i}`) as HTMLIonImgElement)!.src =
													resource == "maps"
														? map3D
														: resource == "summaries"
															? summary3D
															: resource == "keywords_collections"
																? keywords3D
																: resource == "audiobooks"
																	? audio3D
																	: resource == "flashcards_collections"
																		? flashCards
																		: "";
											}
										}}
									>
										<IonSpinner className="delete-icon" id={`delete-spinner-${resource}`} />

										<IonIcon
											id={`delete-${resource}`}
											icon={removeResourceIcon}
											className="delete-icon"
											onClick={(event) => {
												event.stopPropagation();
												this.startResourceLoading(resource);
												this.setState({ resourceToRemove: resource, showConfirmationPopover: true, deleting: true, resourceId: resourceData.id });
											}}
										/>
										<IonCardContent className="sessionDetailsResourceCardContent">
											<IonImg
												id={`resourceImg-${i}`}
												className={resourceData ? "sessionDetailsResourceIcon" : "sessionDetailsResourceIcon missingResourceImage"}
												style={!resourceData ? { opacity: 0.2 } : {}}
												src={
													resource == "maps"
														? map3D
														: resource == "summaries"
															? summary3D
															: resource == "keywords_collections"
																? keywords3D
																: resource == "audiobooks"
																	? audio3D
																	: resource == "flashcards_collections"
																		? flashCards
																		: ""
												}
											/>
											{!resourceData &&
												<IonSpinner
													hidden={
														(!this.state.isLoadingMap &&
															!this.state.isLoadingSummary &&
															!this.state.isLoadingKeywords &&
															!this.state.isLoadingAudiobook &&
															!this.state.isLoadingFlashcards) ||
														(resource === "flashcards_collections" && !this.state.isLoadingFlashcards) ||
														(resource === "maps" && !this.state.isLoadingMap) ||
														(resource === "audiobooks" && !this.state.isLoadingAudiobook) ||
														(resource === "summaries" && !this.state.isLoadingSummary) ||
														(resource === "keywords_collections" && !this.state.isLoadingKeywords)
													}
													name="crescent"
												/>
											}
										</IonCardContent>
										<IonCardTitle className="sessionDetailsResourceType">
											{i18n.t(
												resource == "maps"
													? "Mappa"
													: resource == "summaries"
														? "Riassunto"
														: resource == "keywords_collections"
															? "Parole chiave"
															: resource == "audiobooks"
																? "Audiolibro"
																: resource == "flashcards_collections"
																	? "Flashcards"
																	: ""
											)}
										</IonCardTitle>
										{resource === 'flashcards_collections' &&
											<IonCardContent className="flashcardsDescription">
												<p><Trans>Schede didattiche di memorizzazione</Trans></p>
											</IonCardContent>
										}
									</IonCard>
								);
							})}
							{/* TO REMOVE THIS AFTER IMPLEMENTING THE RESOURCE REGENERATION */}

						</div>
						<IonPopover
							isOpen={this.state.showArgumentInputPopover}
							onDidDismiss={() => this.setState({ showArgumentInputPopover: false, selectedMissingResourceName: "" })}
							className="argumentInputPopover"
						>
							<div className="argumentInputPopoverDiv">
								<p className="argumentInputPopoverTitle">Inserisci l' argomento {/* to localize this */}</p>
								<IonInput
									className="argumentInputPopoverInput"
									onInput={(e) => {
										if (e.currentTarget.value)
											this.setState({ missingResourceArgumentString: e.currentTarget.value.toString(), newArgument: e.currentTarget.value.toString() });
									}}
									debounce={200}
									placeholder="Inserisci l'argomento..."
								/>
								<IonButton
									className="argumentInputPopoverButton"
									disabled={this.state.missingResourceArgumentString.trim().length < 3}
									onClick={() => {
										// Add argument to the session
										//TODO REBUILD LOGIC FOR REGENERATION
										/*
										let resourceName = this.state.missingAudio && this.state.missingSummary && (this.state.selectedMissingResourceName === "audio" || this.state.selectedMissingResourceName === "summary") ? "summary" : this.state.selectedMissingResourceName;
										console.log("REGENERATE:", resourceName);
										if (this.state.argument && this.state.selectedMissingResourceName) getStudySession.call(this, resourceName, this.state.argument);
										this.setState({ showArgumentInputPopover: false, selectedMissingResourceName: "" });
										this.state.missingAudio && this.state.missingSummary && (this.state.selectedMissingResourceName === "audio" || this.state.selectedMissingResourceName === "summary")
											? this.setState({ isLoadingAudiobook: true, isLoadingSummary: true })
											: this.startResourceLoading(this.state.selectedMissingResourceName);
										let resourcesNames = this.state.missingAudio && this.state.missingSummary && (this.state.selectedMissingResourceName === "audio" || this.state.selectedMissingResourceName === "summary") ? ["audio", "summary"] : resourceName
										setLocalStorageSessionState(true, this.state.argument!.uuid, resourcesNames, "creation", this.state.argument?.title)
*/
									}}
								>
									Conferma {/* TO LOCALIZE THIS */}
								</IonButton>
								<p
									onClick={() => {
										/* HANDLE FILE UPLOAD */
										document.getElementById("argumentFile")?.click();
									}}
									className="sessionsHomeUploadParagraph"
								>
									oppure carica 📤 un documento
								</p>
							</div>
						</IonPopover>
						<IonPopover
							isOpen={this.state.showConfirmationPopover || this.state.eliminateSessionConfirmation}
							onDidDismiss={() => {
								this.state.resourceToRemove === 'maps' ? this.setState({ isLoadingMap: false }) :
									this.state.resourceToRemove === 'summaries' ? this.setState({ isLoadingSummary: false }) :
										this.state.resourceToRemove === 'keywords_collections' ? this.setState({ isLoadingKeywords: false }) :
											this.state.resourceToRemove === 'flashcards_collections' ? this.setState({ isLoadingFlashcards: false }) :
												this.setState({ isLoadingAudiobook: false })
								this.setState({
									resourceToRemove: "",
									showConfirmationPopover: false,
								});
							}}
							className="argumentInputPopover"
						>
							<div className="deleteConfimrationPopoverDiv">
								<p className="deleteConfimrationPopoverTitle">{this.state.eliminateSessionConfirmation ? i18n.t("Vuoi davvero eliminare la sessione?") : i18n.t("Vuoi davvero rimuovere l'elemento?")}  {/* to localize this */}</p>
								<p className="deleteConfimrationPopoverContent">{this.state.eliminateSessionConfirmation ? i18n.t("Se si conferma, ad eliminazione avvenuta sarai reindirizzato alla pagina principale e non potrai recuperare i dati.") : i18n.t("Se si conferma, ad eliminazione avvenuta non potrai recuperare la risorsa.")}</p>
								<div className="deleteConfimrationPopoverBtns">
									<IonButton
										className="deleteConfimrationPopoverButton"
										onClick={() => {

											if (this.state.eliminateSessionConfirmation) {
												this.setState({
													eliminateSessionConfirmation: false
												})
												let config = {
													headers: {
														Authorization: `Bearer ${this.state.bearerToken}`,
													},
												};
												argumentServices.deleteSingleStudySession(this.props.history.location.state.argument.id, config).then((response) => {
													console.log(response)
													this.props.history.push({
														pathname: `/sessions/`,
													})
												})
												console.log("elimina")
											} else {
												this.setState({ showConfirmationPopover: false });
												deleteSessionElement(this.state.resourceId, this.state.bearerToken, this.state.resourceToRemove!).then((response) => {
													if (response) {
														this.setState({ deleteElements: false }, () => {
															this.reloadArguments();
														});
														console.log(this.state.argument?.id)
														setLocalStorageSessionState(true, this.state.argument!.id, this.state.resourceToRemove?.toLowerCase(), "")
													}
												});

											}
										}}
									>
										<Trans>Conferma</Trans> {/* TO LOCALIZE THIS */}
									</IonButton>
									<IonButton
										className="argumentDismissBtn"
										onClick={() => {
											if (this.state.eliminateSessionConfirmation) {
												this.setState({
													eliminateSessionConfirmation: false
												})
											} else {
												document.getElementById(`delete-${this.state.resourceToRemove}`)!.style.display = "block"
												document.getElementById(`delete-spinner-${this.state.resourceToRemove}`)!.style.display = "none"
												this.setState({ showConfirmationPopover: false })
											}
										}}
									>
										<Trans>Annulla</Trans> {/* TO LOCALIZE THIS */}
									</IonButton>
								</div>
							</div>
						</IonPopover>
						<GetPremiumPopover
							userUuid={this.state.userData ? this.state.userData.uid : ""}
							isOpen={this.state.showPremiumPopover}
							history={this.props.history}
							onGetPremiumButtonPressed={() => {
								this.props.history.push('/purchase')
								return
								// this.setState({ showPremiumPopover: false, isloadingPaymentSession: true });
								// const createCheckoutSession = httpsCallable(functions, "createCheckoutSession-createCheckoutSession")
								// createCheckoutSession({})
								// 	.then(res => {
								// 		this.setState({ isloadingPaymentSession: false })
								// 		console.log("[Purchase] checkout session res:", res);
								// 		if (res.data && (res.data as any).sessionUrl) {
								// 			window.location.replace((res.data as any).sessionUrl);
								// 		}
								// 	})
								// 	.catch(err => {
								// 		console.log("[Purchase] error creating checkout session:", err);
								// 	})
							}}
							onDidDismiss={() => {
								this.setState({ showPremiumPopover: false });
							}}
						/>
					</div>
				)}
				{/* {this.state.isFetchingResources &&
					/* TO LOCALIZE THIS
					<IonLoading isOpen={this.state.isFetchingResources} message={i18n.t('Sto caricando le risorse...')} />
				} */}
			</IonPage>
		);
	}
}

const mapStateToProps = (state: any) => {
	return {
		orgData: state.user.organization,
	};
};

const mapDispatchToProps = (dispatch: any) => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SessionDetails);
